<script setup lang="ts">
import { IS_IBG_MANAGER } from "@/consts";
import SVG from "@/stories/displays/SVG/SVG.vue";
</script>

<template>
  <div
    v-if="IS_IBG_MANAGER"
    class="w-full justify-center items-center hidden desktop:flex"
  >
    <RouterLink
      to="/support"
      class="bg-darkOcean600 w-full flex items-center p-3 rounded-full gap-2 h200 relative focus-visible-inverse"
    >
      <SVG icon="fas-circle-question" width="1rem" height="1rem"></SVG>
      <div class="flex-grow">
        {{ $t("support.navigation_link") }}
      </div>
    </RouterLink>
  </div>
</template>
